import { friendlyErrorMessage } from '../../../../shared/friendlyError';
import { ApiError } from '../../../identity/types';

/** The plain sentence for a failure, and the reference id when the server sent one (the shared friendlyError copy already carries it for a 5xx). */
export function departmentFailure(err: unknown): { message: string; reference: string | null } {
  if (err instanceof ApiError && err.status === 403) {
    return { message: 'You do not have permission to add departments. Ask a company administrator who can manage employees to add it, or choose an existing department.', reference: err.operationId };
  }
  const message = friendlyErrorMessage(err, 'The department could not be added. Nothing was saved. Please try again.');
  const reference = err instanceof ApiError ? err.operationId : null;
  return { message, reference: reference && !message.includes(reference) ? reference : null };
}

